import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20;
import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { get } from '../../styles/constant';
import Icon from '../Icon';
const primaryOrFilledStyles = {
  backgroundColor: get('colors.primary.blue.900'),
  color: get('colors.functional.grey.50'),
  borderColor: get('colors.functional.grey.50'),
  border: 'none',
  borderWidth: get('space.1'),
  '&:hover': {
    backgroundColor: get('colors.primary.blue.800')
  },
  '&:disabled': {
    backgroundColor: props => "".concat(get('colors.primary.blue.900')(props), "80"),
    pointerEvents: 'none'
  },
  '&:active': {
    backgroundColor: get('colors.functional.grey.900')
  },
  '&:focus': {
    borderWidth: get('space.1'),
    borderColor: get('colors.primary.blue.100')
  }
};
const secondaryOrOutlinedStyles = {
  backgroundColor: get('colors.functional.grey.50'),
  color: get('colors.functional.grey.800'),
  borderColor: get('colors.functional.grey.400'),
  borderWidth: get('space.1'),
  '&:hover': {
    backgroundColor: get('colors.functional.grey.200')
  },
  '&:disabled': {
    backgroundColor: props => "".concat(get('colors.functional.grey.100')(props), "80"),
    borderColor: props => "".concat(get('colors.functional.grey.400')(props), "80"),
    color: props => "".concat(get('colors.functional.grey.800')(props), "80"),
    pointerEvents: 'none'
  },
  '&:active': {
    backgroundColor: get('colors.functional.grey.400')
  },
  '&:focus': {
    borderWidth: get('space.1'),
    borderColor: get('colors.primary.blue.100')
  }
};
const appearances = variant({
  variants: {
    filled: primaryOrFilledStyles,
    primary: primaryOrFilledStyles,
    filledAlt: {
      backgroundColor: get('colors.primary.blue.300'),
      color: get('colors.functional.grey.50'),
      borderColor: get('colors.functional.grey.50'),
      borderWidth: get('space.1'),
      border: 'none',
      '&:hover': {
        backgroundColor: get('colors.primary.blue.200')
      },
      '&:disabled': {
        backgroundColor: props => "".concat(get('colors.primary.blue.300')(props), "80"),
        pointerEvents: 'none'
      },
      '&:active': {
        backgroundColor: get('colors.primary.blue.400')
      },
      '&:focus': {
        borderWidth: get('space.1'),
        borderColor: get('colors.primary.blue.100')
      }
    },
    outlined: secondaryOrOutlinedStyles,
    secondary: secondaryOrOutlinedStyles,
    plain: {
      backgroundColor: 'transparent',
      color: get('colors.functional.grey.900'),
      border: 'none',
      '&:hover': {
        backgroundColor: get('colors.functional.grey.200')
      },
      '&:disabled': {
        backgroundColor: props => "".concat(get('colors.functional.grey.100')(props), "50"),
        borderColor: props => "".concat(get('colors.functional.grey.100')(props), "50"),
        color: props => "".concat(get('colors.functional.grey.800')(props), "80"),
        pointerEvents: 'none'
      },
      '&:active': {
        backgroundColor: get('colors.functional.grey.400')
      },
      '&:focus': {
        border: 'solid',
        borderWidth: get('space.1'),
        borderColor: get('colors.primary.blue.100')
      }
    }
  }
});
const fit = variant({
  prop: 'fit',
  variants: {
    small: {
      padding: props => "".concat(get('space.5')(props), " ").concat(get('space.11')(props)),
      borderRadius: get('borderRadius.s'),
      minHeight: get('space.32'),
      minWidth: get('space.36'),
      fontSize: get('fontSizes.s'),
      lineHeight: get('space.20')
    },
    medium: {
      // TODO: To fix the ButtonProps type
      // padding: (props: ButtonProps) => `${get('space.7')(props)} ${get('space.15')(props)}`,
      padding: '7px 15px',
      borderRadius: get('borderRadius.m'),
      minWidth: get('space.40'),
      fontSize: get('fontSizes.m'),
      lineHeight: get('space.24')
    },
    large: {
      // TODO: To fix the ButtonProps type
      // padding: (props: ButtonProps) =>
      //   `${get('space.11')(props)} ${get('space.23')(props)}`,
      padding: '11px 23px',
      borderRadius: get('borderRadius.l'),
      minWidth: get('space.48'),
      fontSize: get('fontSizes.l'),
      lineHeight: get('space.24'),
      height: '48px'
    }
  }
});
const borderRadiusFit = variant({
  prop: 'fit',
  variants: {
    small: {
      borderRadius: get('borderRadius.s')
    },
    medium: {
      borderRadius: get('borderRadius.m')
    },
    large: {
      borderRadius: get('borderRadius.l')
    }
  }
});
const justifyItems = variant({
  prop: 'justifyItems',
  variants: {
    center: {
      justifyContent: 'center'
    },
    left: {
      justifyContent: 'left'
    },
    right: {
      justifyContent: 'right'
    },
    spaceBetween: {
      justifyContent: 'space-between'
    }
  }
});
const loaderFit = variant({
  prop: 'fit',
  variants: {
    small: {
      maxHeight: get('space.20'),
      top: get('space.9')
    },
    medium: {
      maxHeight: get('space.20'),
      top: get('space.13')
    },
    large: {
      maxHeight: get('space.20'),
      top: get('space.16')
    }
  }
});
const variants = {
  appearances,
  borderRadiusFit,
  fit,
  loaderFit,
  justifyItems
};
const styles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  text-align: center;\n  cursor: pointer;\n  border-width: 1px;\n  border-style: solid;\n  display: inline-flex;\n  position: relative;\n  text-decoration: none;\n  & span {\n    font-weight: ", ";\n  }\n"])), get('fontWeights.light'));
const CommonWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  width: ", ";\n  cursor: ", ";\n}\n"])), props => props.width === 'full-width' ? '100%' : props.width === 'auto' ? 'auto' : "".concat(props.width, "%"), props => props.disabled ? 'not-allowed' : 'default');
const LoaderWrapper = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  display: flex;\n  position: absolute;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  .button-loader {\n    background-color: transparent;\n  }\n"])), variants.loaderFit);
const commonCss = _ref => {
  let {
    $loading,
    icon,
    iconPosition,
    label,
    fit,
    width
  } = _ref;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: ", ";\n    & i {\n      margin-left: 0;\n      margin-right: 0;\n      ", ";\n    }\n\n    & span {\n      ", ";\n      margin-left: ", ";\n      margin-right: ", ";\n    }\n  "])), () => width === 'auto' ? 'auto' : '100%', () => $loading && {
    visibility: 'hidden'
  }, () => $loading && {
    visibility: 'hidden'
  }, () => icon ? iconPosition === 'left' && label && label.length > 0 ? fit === 'small' ? get('space.6') : get('space.8') : get('space.0') : 0, () => icon ? iconPosition === 'right' && label && label.length > 0 ? fit === 'small' ? get('space.6') : get('space.8') : get('space.0') : 0);
};
const getVariantAppearance = _ref2 => {
  let {
    variant,
    appearance,
    active
  } = _ref2;
  // primary
  if (variant === 'filled' || variant === 'primary') {
    if (appearance === 'default') {
      //already taken care above
      return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), active ? get('colors.functional.grey.900') : get('colors.primary.blue.900'));
    } else if (appearance === 'alt') {
      return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n        border-color: ", ";\n        :hover {\n          background-color: ", ";\n        }\n        :disabled {\n=          background-color: ", ";\n          pointer-events: 'none';\n        }\n        :active {\n          background-color: ", ";\n        }\n      "])), active ? get('colors.primary.blue.400') : get('colors.primary.blue.300'), get('colors.functional.grey.50'), get('colors.functional.grey.50'), get('colors.primary.blue.200'), get('colors.primary.blue.300'), get('colors.primary.blue.400'));
    } else if (appearance === 'inverse') {
      return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n        border: none;\n        border-color: ", ";\n        :hover {\n          background-color: ", ";\n        }\n        :disabled {\n          background-color: ", ";\n          pointer-events: 'none';\n        }\n        :active {\n          background-color: ", ";\n        }\n      "])), active ? get('colors.functional.grey.400') : get('colors.functional.grey.50'), get('colors.primary.blue.900'), get('colors.functional.grey.50'), get('colors.functional.grey.200'), get('colors.functional.grey.50'), get('colors.functional.grey.400'));
    } else {
      if (appearance === 'error') {
        return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          background-color: ", ";\n          color: ", ";\n          border: none;\n          border-color: ", ";\n          :hover {\n            background-color: ", ";\n          }\n          :disabled {\n            background-color: ", ";\n            pointer-events: 'none';\n            opacity: 0.5;\n          }\n          :active {\n            background-color: ", ";\n          }\n        "])), active ? get('colors.secondary.red.700') : get('colors.feedback.danger.normal'), get('colors.functional.grey.50'), get('colors.feedback.danger.normal'), get('colors.secondary.red.700'), get('colors.feedback.danger.normal'), get('colors.functional.grey.400'));
      }
    }
  }
  if (variant === 'filledAlt') {
    //do nothing. This is kept to maintain consistency with older version.
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "])), active ? get('colors.primary.blue.400') : get('colors.functional.blue.300'));
  }
  //mapped to secondary of mds
  else if (variant === 'outlined' || variant === 'secondary') {
    if (appearance === 'default') {
      //already taken care above
      return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), active ? get('colors.functional.grey.400') : get('colors.functional.grey.50'));
    } else if (appearance === 'alt') {
      return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n        border-color: ", ";\n        :hover {\n          background-color: ", ";\n        }\n        :disabled {\n          background-color: ", ";\n          pointer-events: 'none';\n        }\n        :active {\n          background-color: ", ";\n        }\n      "])), active ? get('colors.functional.grey.400') : get('colors.functional.grey.200'), get('colors.primary.blue.900'), get('colors.functional.grey.400'), get('colors.functional.grey.100'), get('colors.functional.grey.200'), get('colors.functional.grey.400'));
    } else if (appearance === 'inverse') {
      return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n        border-color: ", ";\n        border: none;\n        :hover {\n          background-color: ", ";\n        }\n        :disabled {\n          background-color: ", ";\n          pointer-events: 'none';\n        }\n        :active {\n          background-color: ", ";\n        }\n      "])), active ? get('colors.primary.blue.800') : get('colors.primary.blue.900'), get('colors.functional.grey.50'), get('colors.functional.grey.50'), get('colors.primary.blue.800'), get('colors.primary.blue.900'), get('colors.primary.blue.900'));
    } else {
      if (appearance === 'error') {
        return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n          background-color: ", ";\n          color: ", ";\n          border-color: ", ";\n          :hover {\n            background-color: rgba(184, 0, 18, 0.06);\n          }\n          :disabled {\n            background-color: ", ";\n            border-color: ", ";\n            color: ", ";\n            opacity: 0.5;\n            pointer-events: 'none';\n          }\n          :active {\n            background-color: ", ";\n          }\n        "])), active ? 'rgba(184, 0, 18, 0.1)' : get('colors.functional.grey.50'), get('colors.secondary.red.600'), get('colors.secondary.red.600'), get('colors.functional.grey.50'), get('colors.secondary.red.50'), get('colors.secondary.red.50'), get('colors.functional.grey.400'));
      }
    }
  } else {
    if (appearance === 'default') {
      //already taken care above
      return css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "])), active ? get('colors.functional.grey.400') : 'transparent');
    } else if (appearance === 'alt') {
      return css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n        border-color: ", ";\n        :hover {\n          background-color: ", ";\n        }\n        :disabled {\n          background-color: ", ";\n          pointer-events: 'none';\n        }\n        :active {\n          background-color: ", ";\n        }\n      "])), active ? get('colors.functional.grey.400') : get('colors.functional.grey.200'), get('colors.primary.blue.600'), get('colors.functional.grey.200'), get('colors.functional.grey.100'), get('colors.functional.grey.200'), get('colors.functional.grey.400'));
    } else if (appearance === 'inverse') {
      return css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        color: ", ";\n        border-color: ", ";\n        border: none;\n        :hover {\n          background-color: ", ";\n        }\n        :disabled {\n          background-color: ", ";\n          pointer-events: 'none';\n        }\n        :active {\n          background-color: ", ";\n        }\n      "])), get('colors.primary.blue.900'), get('colors.functional.grey.50'), get('colors.functional.grey.900'), get('colors.primary.blue.800'), get('colors.primary.blue.900'), get('colors.primary.blue.900'));
    } else {
      if (appearance === 'error') {
        return css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n          background-color: ", ";\n          color: ", ";\n          :hover {\n            background-color: rgba(184, 0, 18, 0.06);\n          }\n          :disabled {\n            background-color: rgba(184, 0, 18, 0.06);\n            color: ", ";\n            opacity: 0.5;\n            pointer-events: 'none';\n          }\n          :active {\n            background-color: rgba(184, 0, 18, 0.06);\n          }\n        "])), active ? 'rgba(184, 0, 18, 0.1)' : get('colors.functional.grey.50'), get('colors.secondary.red.600'), get('colors.secondary.red.600'));
      }
    }
  }
};
const ButtonArea = styled.button.attrs(_ref3 => {
  let {
    type,
    fit,
    width,
    onClick,
    children,
    icon
  } = _ref3;
  return {
    onClick,
    type,
    fit,
    width,
    children,
    icon
  };
}).withConfig({
  shouldForwardProp: prop => !['width', 'fit', 'icon', 'iconPosition', 'appearance', 'justifyItems', 'variant'].includes(prop)
})(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), styles, variants.appearances, variants.fit, variants.justifyItems, props => getVariantAppearance(props), props => commonCss(props), props => props.$loading && {
  pointerEvents: 'none',
  touchAction: 'none'
});
const Anchor = styled.a.attrs(_ref4 => {
  let {
    type,
    fit,
    width,
    onClick,
    children,
    icon
  } = _ref4;
  return {
    onClick,
    type,
    fit,
    width,
    children,
    icon
  };
}).withConfig({
  shouldForwardProp: prop => !['width', 'fit', 'icon', 'iconPosition', 'appearance', 'justifyItems', 'variant'].includes(prop)
})(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n \n"])), styles, variants.appearances, variants.fit, variants.borderRadiusFit, variants.justifyItems, props => getVariantAppearance(props), props => props.$loading && {
  pointerEvents: 'none',
  touchAction: 'none'
}, props => commonCss(props));
const IconWrapper = styled(Icon)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  padding-top: ", ";\n  padding-bottom: ", ";\n"])), props => props.label && props.label.length > 0 ? '0' : get('space.2'), props => props.label && props.label.length > 0 ? '0' : get('space.2'));
const Components = {
  Anchor,
  ButtonArea,
  CommonWrapper,
  IconWrapper,
  LoaderWrapper
};
export { Components };